// Footer.js
import React, { useState } from 'react';
import './footer.css';

import { 
  FaShieldAlt, FaLeaf, FaMedal, FaMapMarkerAlt, FaPhoneAlt, 
  FaEnvelope, FaClock, FaPaperPlane, FaSpinner, FaArrowUp,
  FaFacebookF, FaInstagram, FaTripadvisor, FaWhatsapp,
  FaCcVisa, FaCcMastercard, FaCcAmex, FaCcPaypal,
  FaCcApplePay, FaGooglePay, FaCar, FaStar, FaHeart, FaShieldAlt as FaShield
} from 'react-icons/fa';

function Footer() {
  const [email, setEmail] = useState('');
  const [status, setStatus] = useState('idle'); // idle | loading | success

  const scrollToTop = () => window.scrollTo({ top: 0, behavior: 'smooth' });

  const handleSubscribe = async (e) => {
    e.preventDefault();
    setStatus('loading');
    // Fake delay → in real app → API call
    setTimeout(() => {
      setStatus('success');
      setEmail('');
      alert('Thank you for subscribing to Ceylon Wayfinder updates!');
      setTimeout(() => setStatus('idle'), 4000);
    }, 1200);
  };



  const openSocial = (platform) => {
    const links = {
      facebook:    'https://www.facebook.com/share/1AhqCgay8t/',
      instagram:   'https://www.instagram.com/ceylonwayfinder/',
      tripadvisor: 'https://tripadvisor.com/ceylonwayfinder',
    };
    if (links[platform]) window.open(links[platform], '_blank', 'noopener,noreferrer');
  };

  return (
    <footer className="footer">
      <img
        src="/f footer.jpg"
        alt="Ceylon Wayfinder - Premium Taxi Services in Sri Lanka"
        className="footer-bg"
        loading="lazy"
      />

      <div className="footer-overlay">
        <div className="footer-container">

          {/* Brand Section */}
          <div className="footer-brand">
            <div className="footer-logo">
              <img src="/ceylon wayfinder.png" alt="Ceylon Wayfinder" loading="lazy" />
            </div>
            <p className="brand-text">
              Premium, trustworthy & reliable taxi services across Sri Lanka. 
              Your safety and comfort are our highest priority, experience 
              the journey with confidence.
            </p>
{/* 
            <div className="trust-badges">
              <div className="trust-badge" title="Licensed & Insured"><FaShieldAlt /> Licensed</div>
              <div className="trust-badge" title="Eco-Friendly Fleet"><FaLeaf /> Eco-Friendly</div>
              <div className="trust-badge" title="Premium Service"><FaMedal /> Premium</div>
              <div className="trust-badge" title="24/7 Support"><FaClock /> 24/7 Support</div>
            </div> */}
          </div>

          {/* Quick Links */}
          <div className="footer-column">
            <h4>Quick Links</h4>
            <ul>
              <li><a href="/aboutus">About Us</a></li>
              <li><a href="/services">Our Services</a></li>
              <li><a href="/fleet">Our Fleet</a></li>
              <li><a href="/contactus">Contact</a></li>
              <li><a href="/#">Travel Guide</a></li>
              <li><a href="/#">FAQs</a></li>
              <li><a href="/#">Privacy Policy</a></li>
              <li><a href="/#">Terms of Use</a></li>
            </ul>
          </div>

          {/* Contact & Info */}
          <div className="footer-column">
            <h4>Contact Us</h4>
            <address>
              <p><FaMapMarkerAlt className="contact-icon" />103/C, temple road, walpala, andiambalama</p>
              <p>
                <FaPhoneAlt className="contact-icon" />
                <a href="tel:+94775147957"><b>+94 77 514 7957</b></a>
              </p>
              <p>
                <FaEnvelope className="contact-icon" />
                <a href="mailto:info@ceylonwayfinder.lk"><b>info@ceylonwayfinder.lk</b></a>
              </p>
              <p>
                <FaClock className="contact-icon" />
                24/7 Customer Support
              </p>
            </address>
          </div>

          {/* Newsletter & Social */}
          <div className="footer-column newsletter-col">
            <h4>Stay Updated</h4>
            <p className="newsletter-hint">
              Exclusive offers, travel tips & seasonal discounts
            </p>

            <form onSubmit={handleSubscribe} className="newsletter-form">
              <input
                type="email"
                placeholder="Your email address"
                value={email}
                onChange={e => setEmail(e.target.value)}
                required
                disabled={status === 'loading'}
                aria-label="Email address for newsletter"
              />
              <button
                type="submit"
                disabled={status === 'loading'}
                aria-label="Subscribe"
              >
                {status === 'loading' ? <FaSpinner className="spin" /> : <FaPaperPlane />}
              </button>
            </form>

            <div className="social-icons">
              <button onClick={() => openSocial('facebook')} aria-label="Facebook">
                
                <FaFacebookF />

              </button>

              <button onClick={() => openSocial('instagram')} aria-label="Instagram">
               
                <FaInstagram />
               
              </button>
              <button onClick={() => openSocial('tripadvisor')} aria-label="TripAdvisor">
                <FaTripadvisor />
              </button>
              <a href="https://wa.me/94775147957" target="_blank" rel="noopener noreferrer" aria-label="WhatsApp">
                <FaWhatsapp />
              </a>
            </div>

            {/* Trust Badge Row */}
            <div className="trust-strip">
              <span><FaStar className="star-icon" /> 5/5 Rating</span>
              <span><FaHeart /> 100% Secure</span>
            </div>
          </div>

        </div> {/* .footer-container */}

        <hr className="footer-divider" />

        <div className="footer-bottom">

      {/* Copyright */}
      <div className="copyright">
        <p>&copy; {new Date().getFullYear()} Ceylon Wayfinder. All Rights Reserved. |  Designed and Developed by 
  <a 
    className="glaxmore-link" 
    href="https://www.glaxmore.com" 
    target="_blank" 
    rel="noopener noreferrer"
  >
    &ensp; GLAXMORE
  </a>
</p>
      </div>


          <div className="payment-icons">
            <FaCcVisa title="Visa" />
            <FaCcMastercard title="Mastercard" />
            {/* <FaCcAmex title="American Express" />
            <FaCcPaypal title="PayPal" />
            <FaCcApplePay title="Apple Pay" />
            <FaGooglePay title="Google Pay" /> */}
          </div>

          <button className="back-to-top" onClick={scrollToTop} aria-label="Scroll to top">
            <FaArrowUp /> Top
          </button>
        </div>

        {/* Decorative element */}
        <div className="footer-decor-car" aria-hidden="true">
          <FaCar />
        </div>
      </div>
    </footer>
  );
}

export default Footer;